/**
 * API Endpoints Constants
 * Centralized location for all API endpoints
 * Change endpoints here to update them everywhere in the application
 */

export const API_ENDPOINTS = {
  // Authentication
  LOGIN: "/login",

  //Get_Images_By_Id
  SEARCH_IMAGE_BY_ID: (id) => `/api/getProfilePhoto/${id}`, 
  // Patient APIs
  PATIENT_DETAILS: "/api/patientdetails",
  ADD_PATIENT_DETAILS: "/api/addpatientdetails",
  EDIT_PATIENT_DETAILS: "/api/editpatientdetails",
  SEARCH_PATIENT_DETAILS: "/api/searchpatientdetails",
  DELETE_PATIENT_DETAILS: "/api/deletepatientdetails",
  PATIENT_DASHBOARD: "/api/patientdashboard",

  // Camp APIs
  GET_DASHBOARD_CAMP: "/api/getdashboardcamp",
  CAMP_DETAILS: "/api/campdetails",
  SEARCH_CAMP_DETAILS: "/api/searchcampdetails",
  CAMP_USER_LIST: "/api/get-camp-user-list",
  CAMP_MANAGER_REPORT_PATIENT_DASHBOARD: "/api/camp-manager-report-patient-dashboard",
  CAMP_MANAGER_REPORT_PATIENT: "/api/camp-manager-report-patient",
  CAMP_MANAGER_REPORT_RESOURCE: "/api/camp-manager-report-resource",
  CAMP_MANAGER_REPORT_RESOURCE_DASHBOARD: "/api/camp-manager-report-resource-dashboard",
  ADD_CAMP_DETAILS: "/api/addcampdetails",
  EDIT_CAMP_DETAILS: "/api/editcampdetails",

  // Organization APIs
  ORGANIZATION_DETAILS: "/api/organization-details",
  SEARCH_ORGANIZATION_DETAILS: "/api/search-organization-details",
  GET_DASHBOARD_ORGANIZATION: "/api/get-dashboard-organization",
  EDIT_ORGANIZATION_DETAILS: "/api/edit-organization-details",
  ADD_ORGANIZATION_DETAILS: "/api/add-organization-details",
  GET_EXISTING_ORGANIZATIONS:"/api/getexistingorganization",

  // Camp Type APIs
  CAMP_TYPE: "/api/camptype",

  // Patient Transportation APIs
  PATIENT_TRANSPORTATION_DASHBOARD: "/api/patienttransportationdashboard",
  PATIENT_TRANSPORTATION_DETAILS: "/api/patienttransportationdetails",

  // Patient Visit APIs
  PATIENT_VISIT_DETAILS: "/api/patientvisitdetails",
  ADD_PATIENT_VISIT_DETAILS: "/api/addpatientvisitdetails",
  EDIT_PATIENT_VISIT_DETAILS: (id) => `/api/editpatientvisitdetails/${id}`,
  GET_ALL_PATIENT_VISIT_DETAILS: "/api/get-all-patient-visit-details",
  SEARCH_PATIENT_VISIT_DETAILS: "/api/searchpatientvisitdetails",
  PATIENT_VISIT_DASHBOARD : "/api/PatientVisitDashboard",

  // Examiner APIs
  GET_EXAMINER_DETAILS: "/api/get-examiner-details",
  USER_DETAILS: "/api/userDetails",
  GET_DOCTOR_DETAILS: "/api/get-doctor-details",

  // Lookup APIs
  SEARCH_LOOKUP_DETAILS: "/api/searchlookupdetails",
  ADD_LOOKUP_DETAILS: "/api/addlookupdetails",

  // User APIs
  USER_DETAILS_LIST: "/api/userdetails",
  ADD_USER_DETAILS: "/api/adduserdetails",
  EDIT_USER_DETAILS: "/api/edituserdetails",
  DELETE_USER_DETAILS: "/api/deleteuserdetails",
  ASSIGN_USER_ROLE: "/api/assign-user-role",
  SEARCH_USER_DETAILS: "/api/searchuserdetails",
  USER_PROFILE: "/api/userprofile",
  ADD_USER_TO_ROLE: "/api/add-user-to-role",
  REMOVE_USER: "/api/remove-user",
  EDIT_USER_ROLE: "/api/edit-user-role",
  GET_USER_WITH_ROLE: "/api/get-user-with-role",
  GET_EXISTING_USERS:"/api/existingUser",

  // Role APIs
  GET_ALL_ROLES: "/api/get-all-roles",
  GET_ALL_PERMISSIONS: "/api/get-all-permissions",
  GET_ALL_PERMISSIONS_LIST: "/api/get-all-permissions-list",
  GET_PERMISSIONS_TO_ROLE: "/api/get-permissions-to-role",
  CREATE_ROLE: "/api/create-role",
  EDIT_ROLE: "/api/edit-role",
  GET_ROLE_BASED_USERS: "/api/get-role-based-users",
  ADD_PERMISSIONS_TO_ROLE: "/api/add-permissions-to-role",

  // Payment APIs
  ADD_PAYMENT: "/api/addPayment",
  PRINT_INVOICE: "/api/print-invoice",
  GET_ALL_COLLECTABLE_PAYMENTS: "/api/getAllCollectablePayments",
  PATIENT_FINANCIAL_INFORMATION: "/api/patientfinancialinformation",

  // Invoice APIs
  INVOICE_PATIENT_SEARCH: "/api/invoicePatientSearch",
  ADD_INVOICE: "/api/addinvoice",
  EDIT_INVOICE: "/api/editInvoice",
  GET_INVOICE_BY_ID: "/api/getInvoiceById",
  GET_PATIENT_INVOICE_SUMMARY: "/api/getPatientInvoiceSummary",

  // Donor APIs
  DONOR_DETAILS: "/api/donor-details",
  DONOR_REPORT: "/api/donor-report",
  DONOR_REPORT_DASHBOARD: "/api/donor-report-dashboard",
  GET_DONOR_BY_ID: "/api/get-donor-by-id",
  GET_DONATION_BY_ID: "/api/get-donation-by-id",
  ADD_DONOR_DETAILS: "/api/add-donor-details",
  EDIT_DONOR_DETAILS: "/api/edit-donor-details",
  ADD_DONATION: "/api/add-donation",
  EDIT_DONATION: "/api/edit-donation",
  EXISTING_DONOR:"/api/getexistingdonors",

  // Report APIs
  TENANT_REPORT: "/api/tenant-report",
  TENANT_REPORT_DASHBOARD: "/api/tenant-report-dashboard",
  PATIENT_PRETREATMENT_REPORT: "/api/patient-pretreatment-report",
  PATIENT_POSTTREATMENT_REPORT: "/api/patient-posttreatment-report",
  DOCTOR_REPORT: "/api/doctor-report",
  REPORT: "/api/report",
  PATIENT_TRANSPORTATION_CHART: "/api/patienttransportationchart",
  TREATMENT_BREAKDOWN: "/api/treatmentbreakdown",
  DASHBOARD_APPOINTMENTS: "/api/dashboardappoitments",

  // Logistics APIs
  EDIT_PATIENT_TRANSPORTATION_STATUS: "/api/editPatientTransportationStatus",
  SCHEDULE_NEW_APPOINTMENT: "/api/scheduleNewAppointment",
  FOLLOWUP: "/api/followup",

  // Examination APIs
  SEARCH_POST_SURGERY_FOLLOWUP_DETAILS: "/api/searchPostSurgeryFollowUpDetails",
  ADD_POST_SURGERY_FOLLOWUP_DETAILS: "/api/addPostSurgeryFollowUpDetails",
  EDIT_POST_SURGERY_FOLLOWUP_DETAILS: "/api/editPostSurgeryFollowUpDetails",
  SEARCH_EYE_EXAMINATION_DETAILS: "/api/searchEyeExaminationDetails",
  ADD_EYE_EXAMINATION_DETAILS: "/api/addEyeExaminationDetails",
  EDIT_EYE_EXAMINATION_DETAILS: "/api/editEyeExaminationDetails",
  SEARCH_CLINICAL_INFORMATION_DETAILS: "/api/searchclinicalinformationdetails",
  ADD_CLINICAL_INFORMATION_DETAILS: "/api/addClinicalInformationDetails",
  EDIT_CLINICAL_INFORMATION_DETAILS: "/api/editClinicalInformationDetails",
  SEARCH_SURGERY_RECOMMENDED_DETAILS: "/api/searchSurgeryRecommendedDetails",
  ADD_SURGERY_RECOMMENDED_DETAILS: "/api/addSurgeryRecommendedDetails",
  EDIT_SURGERY_RECOMMENDED_DETAILS: "/api/editSurgeryRecommendedDetails",
  SEARCH_MEDICAL_PRESCRIPTION_DETAILS: "/api/searchMedicalPrescriptionDetails",
  ADD_MEDICAL_PRESCRIPTION_DETAILS: "/api/addMedicine",
  EDIT_MEDICAL_PRESCRIPTION_DETAILS: "/api/editMedicine",
  DELETE_MEDICINE: "/api/deleteMedicine",

  // Notification APIs
  GET_NOTIFICATION_TEMPLATES: "/api/getNotificationTemplates",
  ADD_NOTIFICATION_TEMPLATE: "/api/addNotificationTemplate",
  EDIT_NOTIFICATION_TEMPLATE: (id) => `/api/editNotificationTemplate/${id}`,
  DELETE_NOTIFICATION_TEMPLATE: (id) => `/api/deleteNotificationTemplate/${id}`,
  GET_NOTIFICATION_HISTORY: "/api/get-notification-history",
  GET_NOTIFICATION_BY_USER: "/api/getNotificationByUser",
  ADD_NOTIFICATION: "/api/addNotification",
  GET_ALL_NOTIFICATION_CAMPS: "/api/getAllNotificationcamp",
  DELETE_NOTIFICATION_USER: "/api/deleteNotificationUser",

  // Auth APIs
  CHANGE_PASSWORD: "/api/changepassword",

  // User Management APIs
  GET_ALL_USERS: "/api/get-all-users",

  // SystemSettings APIs
  ADD_COMPANY_LOGO: "/api/add-company-logo",
  ADD_COMPANY_FULL_LOGO : "/api/add-company-full-logo",
  ADD_FAVICON : "/api/add-favicon",
  ADD_LOGIN_LOGO : "api/add-login-logo",

  // Layout APIs
  GET_COMPANY_LOGO : "/api/get-company-logo",
  GET_COMPANY_FULL_LOGO : "/api/get-company-full-logo",
  GET_FAVICON : "/api/get-favicon",
  GET_LOGIN_LOGO : "/api/get-login-logo",

  // User Management APIs
  GET_USER_PROFILE_FOR_CAMP : "/api/getuserprofileforcamp",

}